module.exports = __webpack_public_path__ + "media/Components/fonts/RobotoSlab-a53f435cf7f3b6203c7f1b288a0b61f1.ttf";